import { UserMembershipView } from '@localstack/types';

export const getUserName = (members: UserMembershipView[], userId: string): string | undefined => {
  const member = members.find((m) => m.user_id === userId);
  return member?.user_full_name || member?.user_email || userId;
};
